import React from 'react';
import PropTypes from 'prop-types';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent from '@material-ui/core/CardContent';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { FormattedHTMLMessage } from 'react-intl';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import translations from './translations';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const PRODUCTS_APP_ORIGIN = BASE_URL.replace('{app}', 'products');

export const OrderItemCardSkeleton = props => (
  <Grid item xs={12} {...props}>
    <Card>
      <CardContent>
        <Box display="flex">
          <Box flex={1}>
            <Typography variant="subtitle1">
              <Skeleton variant="text" width="60%" />
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom>
              <Skeleton variant="text" width="40%" />
            </Typography>
          </Box>
          <Box flexBasis={60}>
            <Typography variant="overline" color="textSecondary">
              <Skeleton variant="text" width="100%" />
            </Typography>
            <Typography variant="body2" color="textPrimary">
              <Skeleton variant="text" width="50%" />
            </Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  </Grid>
);

const OrderItemCard = ({ item }) => (
  <Grid item xs={12} key={item.sku}>
    <Card>
      <CardActionArea
        component="a"
        href={`${PRODUCTS_APP_ORIGIN}/products/${encodeURIComponent(item.sku)}`}
      >
        <CardContent>
          <Box display="flex">
            <Box flex={1}>
              <Typography variant="subtitle1">{item.description}</Typography>
              <Typography variant="body2" color="textSecondary" gutterBottom>
                {item.sku}
              </Typography>
            </Box>
            <div>
              <Typography variant="overline" color="textSecondary">
                <FormattedHTMLMessage {...translations.quantity} />
              </Typography>
              <Typography variant="body2" color="textPrimary">
                {item?.quantity}
              </Typography>
            </div>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  </Grid>
);

OrderItemCard.propTypes = {
  item: PropTypes.object,
};

OrderItemCard.defaultProps = {
  item: null,
};

export default OrderItemCard;
